export default "__VITE_ASSET__CF7Rkr2J__"